import {
  GET_USER_PACKAGES_LOG_REQUEST,
  GET_USER_PACKAGES_LOG_SUCCESS,
  GET_USER_PACKAGES_LOG_FAILURE,
} from '../actions/userActions';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export default function userPackagesLog(state = initialState, action) {
  switch (action.type) {
    case GET_USER_PACKAGES_LOG_REQUEST:
      return { loading: true, error: null, data: null };
    case GET_USER_PACKAGES_LOG_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case GET_USER_PACKAGES_LOG_FAILURE:
      return { loading: false, error: action.error || 'Failed to fetch user packages log', data: null };
    default:
      return state;
  }
}


